export default [
  {
    path: '/settings/autobuy',
    redirect: '/settings/autobuy/rules'
  },
  {
    component: () => import(
      './Settings.vue'
    ),
    path: '/settings',
    redirect: '/settings/general',
    children: [
      {
        name: 'settings',
        path: '',
        redirect: '/settings/general'
      },
      {
        component: () => import(
          './Autobuy/AutobuyRules.vue'
        ),
        path: 'autobuy/rules',
        name: 'settings.rules'
      },
      {
        component: () => import(
          './Autobuy/AutobuySettings.vue'
        ),
        path: 'autobuy/general',
        name: 'settings.autobuy'
      },
      {
        component: () => import(
          './General/index.vue'
        ),
        path: 'general'
      },
      {
        component: () => import(
          './Partner.vue'
        ),
        path: 'partner'
      },
      {
        component: () => import(

          './Inventory.vue'
        ),
        path: 'inventory'
      }
    ]
  }
]
